import { useState } from "react";
import { useEffect } from "react";
import brazilIcon from "../../images/png/brazil-.png"
import spainIcon from "../../images/png/spain.png"
import franceIcon from "../../images/png/france.png"
import usaIcon from "../../images/png/united-states-of-america.png"
import italianIcon from "../../images/png/italy.png"
import germanIcon from "../../images/png/german.png"
import arrowIcon from "../../images/svg/arrow.svg"
import { useTranslation } from "react-i18next";

const SelectLanguage = ({width, height}) => {
    const { t, i18n } = useTranslation()
    const [contentBtn, setContentBtn] = useState(false)
    const [select, setSelect] = useState({})

    const [typeLanguage, setTypeLanguage] = useState([
        { name: "Português", type: "pt", icon: brazilIcon },
        { name: "English", type: "en", icon: usaIcon },
        { name: "France", type: "fr", icon: franceIcon },
        { name: "Español", type: "es", icon: spainIcon },
        { name: "Italiano", type: "it", icon: italianIcon },
        { name: "Deutsch", type: "de", icon: germanIcon },
    ]);


    useEffect(() => {
        const language = localStorage.getItem("@STANDARD_LANGUAGE:")

        console.log(language)

        if (!language) {
            setSelect({
                name: "Português",
                icon: brazilIcon,
            })
        }
        if (language == 'en') {
            setSelect({
                name: "English",
                icon: usaIcon,
            })
        }
        if (language == 'fr') {
            setSelect({
                name: "France",
                icon: franceIcon,
            })
        }
        if (language == 'es') {
            setSelect({
                name: "Español",
                icon: spainIcon,
            })
        }
        if (language == 'pt') {
            setSelect({
                name: "Português",
                icon: brazilIcon,
            })
        }
        if (language == 'it') {
            setSelect({
                name: "Italiano",
                icon: italianIcon,
            })
        }
        if (language == 'de') {
            setSelect({
                name: "Deutsch",
                icon: germanIcon,
            })
        }

    }, [])

    const container = {
        width: width,
        borderRadius: height,
    }

    const content = {
        width: "100%",
        height: "50px",
        border: "1px solid #d7d7d7",
        borderRadius: "8px",
        cursor: "pointer",
        position: "relative"
    }

    const boxContent = {
        display: "flex",
        alignItems: "center",
        gap: "10px",
        padding: "10px"
    }

    const image = {
        right: "10px",
        position: "absolute",
        top: "25px",
    }

    const containerContent = {
        width: "270px",
        borderRadius: "8px",
        border: "1px solid #d7d7d7",
        maxHeight: "100px",
        marginTop: "10px",
        padding: "10px",
        overflow: "hidden",
        overflowY: "scroll"
    }



    return (
        <div onClick={() => setContentBtn(!contentBtn)} style={container}>

            <div style={content}>

                {
                    select && <div style={boxContent}>
                        <img style={{ width: "20px", height: "20px", borderRadius: "50%" }} src={select.icon} />
                        <p style={{ marginBottom: "2px" }}>{select.name}</p>
                    </div>
                }

                <img style={image} src={arrowIcon} />
            </div>

            {
                contentBtn &&
                <div style={containerContent}>
                    {
                        typeLanguage.map(item => {
                            return (
                                <div onClick={() => {
                                    localStorage.setItem("@STANDARD_LANGUAGE:", item.type)
                                    i18n.changeLanguage(item.type)
                                    setSelect({
                                        name: item.name,
                                        icon: item.icon,
                                    })
                                }} style={{
                                    display: "flex",
                                    gap: "10px",
                                    cursor: "pointer"
                                }}>
                                    <img style={{ width: "25px", height: "25px", borderRadius: "50%" }} src={item.icon} />

                                    <p>{item.name}</p>
                                </div>
                            )
                        })
                    }
                </div>
            }


        </div>
    )
}

export default SelectLanguage